import React from 'react';
import { Icon } from '@wegroup/design-system';

// Components
import {
  IconCarFilled,
  IconFamilyFilled,
  IconPropertyFilled,
  IconLegalFilled,
  IconOthersFilled,
  IconFuneral,
  IconStats,
  IconHeavyScooter,
} from 'wg-fe-ui';
import ImmoIconCar from '../../../../assets/images/immotheker/ImmoIconCar';
import ImmoIconHouse from '../../../../assets/images/immotheker/ImmoIconHouse';
import ImmoIconLegal from '../../../../assets/images/immotheker/immoIconLegal';

import ImmoIconPeople from '../../../../assets/images/immotheker/ImmoIconPeople';

interface Props {
  riskObject: string;
  color?: string;
  size?: number;
  isImmo?: boolean;
}

const RiskObjectIcon: React.FC<React.PropsWithChildren<Props>> = ({
  riskObject,
  color,
  size,
  isImmo = false,
}) => {
  switch (riskObject.toLowerCase()) {
    case 'boat':
    case 'boats':
      return (
        <Icon name="GeneralRiskObjectsBoat" color={color} boxSize={size} />
      );
    case 'cars':
    case 'car':
      return isImmo ? (
        <ImmoIconCar color={color} />
      ) : (
        <IconCarFilled color={color} size={size} />
      );
    case 'families':
    case 'family':
      return isImmo ? (
        <ImmoIconPeople color={color} />
      ) : (
        <IconFamilyFilled color={color} size={size} />
      );
    case 'residences':
    case 'residence':
    case 'homes':
    case 'home':
      return isImmo ? (
        <ImmoIconHouse color={color} />
      ) : (
        <IconPropertyFilled color={color} size={size} />
      );
    case 'legal':
      return isImmo ? (
        <ImmoIconLegal color={color} />
      ) : (
        <IconLegalFilled color={color} size={size} />
      );
    case 'funeral':
      return <IconFuneral color={color} size={size} />;
    case 'teachers':
    case 'teacher':
      return <IconStats color={color} size={size} />;
    case 'two_wheelers':
    case 'two_wheeler':
      return <IconHeavyScooter color={color} size={size} />;
    case 'bicycle':
      return (
        <Icon
          name="RiskObjectsPersonalLiabilityBike"
          color={color}
          boxSize={size}
        />
      );
    case 'travel':
      return (
        <Icon name="GeneralRiskObjectsFlight" color={color} boxSize={size} />
      );
    default:
      return <IconOthersFilled color={color} size={size} />;
  }
};

export default RiskObjectIcon;
